// No "use client" here: server components import these to mark stagger items

/** Marks an element inside <ScrollStaggerGroup> to fade in with the group */
export const SCROLL_STAGGER_ITEM_CLASS = "animate-fade-in scroll-stagger-item";

/** Marks an element inside <ScrollStaggerGroup> to fade in from blur with the group */
export const SCROLL_STAGGER_BLUR_ITEM_CLASS =
  "animate-blur-in scroll-stagger-item";

/** Selector the group uses to find its items */
export const SCROLL_STAGGER_ITEM_SELECTOR = ".scroll-stagger-item";
